import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import kapi from "../api/kratos";
import org_roles_api from "../api/organisationRoles"
import text_utils from "../utils/TextUtils";
import Slider from "../components/Slider";
import countries from "i18n-iso-countries";
import avatar from "../assets/ccmi-graphic-logo-color.svg";
import eye from "../assets/eye.png";
import check from "../assets/green-tick-circle.svg";
import cross from "../assets/red_cross.png";
import Select from "react-select"
import styles from "../utils/ReactSelectStyles"
import InfoRightPopUp from "../components/InfoRightPopUp";


const Register = () => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [accessCode, setAccessCode] = useState(" "); //SPACE IS REQUIRED WHEN ACCESS CODE IS NOT REQUIRED
    const [organisation, setOrganisation] = useState("");
    const [orgRole, setOrgRole] = useState();
    const [orgRoleSelected, setOrgRoleSelected] = useState(); //needed for react-select, not used in kratos form
    const [country, setCountry] = useState("");
    const [countrySelected, setCountrySelected] = useState(); //needed for react-select, not used in kratos form
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [flowResponse, setFlowResponse] = useState();
    const [countryCodes, setCountryCodes] = useState([]);
    const [organisationRoles, setOrganisationRoles] = useState([]);
    const [processingConsent, setProcessingConsent] = useState(false);
    const [marketingConsent, setMarketingConsent] = useState(false);
    const [showPasswordGuide, setShowPasswordGuide] = useState(false);
    const navigate = useNavigate();

    const [showEmailReminder, setShowEmailReminder] = useState(false);
    const [showFirstnameReminder, setShowFirstnameReminder] = useState(false);
    const [showLastnameReminder, setShowLastnameReminder] = useState(false);
    const [showPasswordReminder, setShowPasswordReminder] = useState(false);
    const [showConfirmPasswordReminder, setShowConfirmPasswordReminder] = useState(false);
    const [showAccessCodesReminder, setShowAccessCodesReminder] = useState(false);
    const [showOrganisationReminder, setShowOrganisationReminder] = useState(false);
    const [showOrgRoleReminder, setShowOrgRoleReminder] = useState(false);
    const [showCountryReminder, setShowCountryReminder] = useState(false);
    const [showConsentReminder, setShowConsentReminder] = useState(false);

    const [diagnosticConsent, setDiagnosticConsent] = useState(false);
    const [coachingConsent, setCoachingConsent] = useState(false);




    const InitRegistration = () => {
        // clear any existing user in storage
        localStorage.removeItem("user");

        let response = kapi.init_registration();
        response.then(response => {
            setFlowResponse(response.data);
        }, function() {
            navigate("/logout");
        })
    }

    const PageLoad = () => {
        const params = new URLSearchParams(window.location.search);
        const flowId = params.get('flow');

        if (!flowId) {
            InitRegistration();
        }
        else {
            const getNodeValue = (nodes, name) =>
                nodes.find(n => n.attributes.name === name)?.attributes.value ?? "";

            let response = kapi.get_registration(flowId);
            response.then(response => {
                setFlowResponse(response.data);
                setFirstName(getNodeValue(response.data.ui.nodes, "traits.name.first"));
                setLastName(getNodeValue(response.data.ui.nodes, "traits.name.last"));
                setEmail(getNodeValue(response.data.ui.nodes, "traits.email"));
                setOrganisation(getNodeValue(response.data.ui.nodes, "traits.organisation"));
                setCountry(getNodeValue(response.data.ui.nodes, "traits.country"));
                setOrgRole(getNodeValue(response.data.ui.nodes, "traits.organisation_role"));
                setAccessCode(getNodeValue(response.data.ui.nodes, "traits.access_code") || " ");
                setProcessingConsent(Number(response.data.ui.nodes.find(n => n.attributes.name === 'traits.processing').attributes.value) === 1)
                setMarketingConsent(Number(response.data.ui.nodes.find(n => n.attributes.name === 'traits.marketing').attributes.value) === 1)
                setDiagnosticConsent(Number(response.data.ui.nodes.find(n => n.attributes.name === 'traits.diagnostic').attributes.value) === 1)
                setCoachingConsent(Number(response.data.ui.nodes.find(n => n.attributes.name === 'traits.coaching').attributes.value) === 1)
            }).catch(err => {
                console.log("Unable to retrieve registration: " + err);
            });
        }
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const toggleShowConfirmedPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const getCountries = () => {
        let items = [];
        countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
        for (const [key, value] of Object.entries(countries.getNames("en", {select: "official"}))){
            let item = {};
            item.code = key;
            item.name = value;
            items.push(item);
        }
        // Sort into alphabetical order
        let sorted_items = items.sort((a, b) => a.name.localeCompare(b.name));
        setCountryCodes(sorted_items);
        setCountry("GB")
        setCountrySelected({code: 'GB', name: 'United Kingdom'})
    }

    const getOrganisationRoles = () => {
        let response = org_roles_api.getOrganisationRoles();
        response.then(response => {
            setOrganisationRoles(response.data.roles)
        }).catch(err => {console.log(err)})
    }

    const updateProcessingConsent = (status) => {
        setProcessingConsent(status);
    }

    const updateMarketingConsent = (status) => {
        setMarketingConsent(status);
    }

    const updateDiagnosticConsent = (status) => {
        setDiagnosticConsent(status);
    }

    const updateCoachingConsent = (status) => {
        setCoachingConsent(status);
    }

    const checkAllPasswordConditions = () => {
        if (!password) return false
        return (text_utils.containsSpecial(password) &&
            text_utils.containsDigit(password) &&
            text_utils.containsCapital(password) &&
            password.length >= 8 &&
            password === confirmPassword)
    }

    const handleFalseButtonClick = (ev) => {
        if(!ev) return;
        ev.preventDefault()
        setShowEmailReminder(!email);
        setShowFirstnameReminder(!firstName);
        setShowLastnameReminder(!lastName);
        setShowPasswordReminder(!password);
        setShowConfirmPasswordReminder(!confirmPassword);
        setShowAccessCodesReminder(!accessCode);
        setShowOrganisationReminder(!organisation);
        setShowOrgRoleReminder(!orgRole)
        setShowCountryReminder(!country);
        setShowConsentReminder(!processingConsent);
    }

    useEffect(() => {
        getCountries();
        getOrganisationRoles();
        PageLoad()
    }, []);

    useEffect(() => {
        if (organisationRoles.length > 0 && orgRole !== undefined && orgRole !== null) {

            const selected = organisationRoles.find(
                r => String(r.id) === String(orgRole)
            );

            if (selected) {
                setOrgRoleSelected(selected);
            }
        }
    }, [organisationRoles, orgRole]);

    useEffect(() => {
        if (countryCodes.length > 0 && country) {
            const selected = countryCodes.find(c => c.code === country);
            if (selected) {
                setCountrySelected(selected);
            }
        }
    }, [countryCodes, country]);

    const handleAccessCodeChange = (ev) => {
        /*For use when access codes are not required*/
        if(ev.target.value.trim() === "") {
            setAccessCode(" ")
        } else if (ev.target.value.trim() !== ""){
            setAccessCode(ev.target.value.trim())
        }
    }

return (
        <>
            <div className="register-page-container">
                <div className="sign-up-container">
                    <div className="register-welcome-container col">
                        <img src={avatar} alt="Logo"/>
                        <div className="register-welcome-title">
                            Create account
                        </div>
                        <div className="register-welcome-subtitle">
                            Sign up to get started
                        </div>
                        <div className="register-login-container">
                            Already have an account?
                            <Link to="/login">Sign in here</Link>
                        </div>
                        <div className="register-privacy-container flex">
                            <a href="https://clutterbuck-cmi.com/">CCMI </a>
                            <a href="privacy">Privacy policy</a>
                        </div>
                        <div className="register-faq">
                            <Link to="/faq" >FAQ/Self Help Guide</Link>
                        </div>
                    </div>
                    <div className="register-form-container col">
                        <form name="register-form" action={flowResponse && flowResponse.ui.action} method="POST" id="register-form">
                            <div>
                                {flowResponse && flowResponse?.ui?.messages?.map((msg, idx) => {
                                    return (
                                        <div className="messages" key={idx}>{msg.text}</div>
                                    )
                                })}
                            </div>
                            <input name="csrf_token" type="hidden"
                                   value={flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'csrf_token')?.attributes.value}/>
                            <div className="field-input">
                                <div className="label">Email</div>
                                <div className="field-input-entry">
                                    <input className="login-input" name="traits.email" type="email" value={email}
                                           onChange={(ev) => setEmail(ev.target.value)}
                                           required/>
                                    {showEmailReminder ? <div className="messages">This field is required.</div> : null}
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">First name</div>
                                    <input name="traits.name.first"
                                           type="text" value={firstName}
                                           onChange={(ev) => setFirstName(ev.target.value)}
                                           required/>
                                    {showFirstnameReminder ? <div className="messages">This field is required.</div> : null}
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'traits.name.first')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Last name</div>
                                    <input name="traits.name.last"
                                           type="text" value={lastName}
                                           onChange={(ev) => setLastName(ev.target.value)}
                                           required/>
                                    {showLastnameReminder ? <div className="messages">This field is required.</div> : null}
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'traits.name.last')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Password</div>
                                    <input name="password"
                                           type={showPassword ? "text" : "password"} value={password}
                                           onChange={(ev) => {
                                               setPassword(ev.target.value)
                                               setShowPasswordGuide(true)
                                           }}
                                           onFocus={() => {
                                               setShowPasswordGuide(true)
                                           }}
                                           required/>
                                    {showPasswordReminder ? <div className="messages">This field is required.</div> : null}
                                    <img src={eye} onClick={toggleShowPassword} alt="eye logo"
                                         className="eye link"/>
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'password')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Confirm password</div>
                                    <input name="confirm-password"
                                           type={showConfirmPassword ? "text" : "password"} value={confirmPassword}
                                           onChange={(ev) => setConfirmPassword(ev.target.value)}
                                           required/>
                                    {showConfirmPasswordReminder ? <div className="messages">This field is required.</div> : null}
                                    <img src={eye} onClick={toggleShowConfirmedPassword} alt="eye logo"
                                         className="eye link"/>
                                </div>
                            </div>
                            {showPasswordGuide && showPasswordGuide ?
                                <div className="password-guide-container">
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={password && password.length >= 8 ? check : cross} alt='password-check'/>
                                        </div>
                                        Minimum number of characters: 8
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={text_utils.containsCapital(password) ? check : cross} alt='password-check'/>
                                        </div>
                                        Include at least 1 capital character
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={text_utils.containsDigit(password) ? check : cross} alt='password-check'/>
                                        </div>
                                        Include at least 1 numeric character
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={text_utils.containsSpecial(password) ? check : cross} alt='password-check'/>
                                        </div>
                                        Include at least 1 special character
                                    </div>
                                    <div className="password-guide-section">
                                        <div className="password-card-image-container">
                                            <img src={password === confirmPassword ? check : cross} alt='password-check'/>
                                        </div>
                                        Passwords must match
                                    </div>
                                </div>
                                : null
                            }
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="register-info-container">
                                        <div className="label">Access Code (if you have one)</div>
                                        <InfoRightPopUp top={-15} left={270} text={"You may have been granted special " +
                                            "access with a code – for example as an attendee on our Team Coaching " +
                                            "training courses."}/>
                                    </div>
                                    <input name="traits.access_code" type="text" value={accessCode}
                                           onChange={handleAccessCodeChange}
                                    />
                                    <div>
                                        {flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'traits.access_code')?.messages.map((msg, idx) => {
                                            return (
                                                <div className="messages" key={idx}>{msg.text}</div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="register-form-divider"></div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Name of Organisation</div>
                                    <input name="traits.organisation"
                                           type="text" value={organisation}
                                           onChange={(ev) => setOrganisation(ev.target.value)}
                                           required/>
                                    {showOrganisationReminder ? <div className="messages">This field is required.</div> : null}
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Organisation Role</div>
                                    <Select name="traits.organisation_role" options={organisationRoles}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.id}
                                            value={orgRoleSelected}
                                            placeholder=""
                                            onChange={ev => {
                                                setOrgRole(ev.id)
                                                setOrgRoleSelected(ev)
                                            }}
                                            styles={styles.registerStyles}
                                            required={true}
                                    />
                                    {showOrgRoleReminder ? <div className="messages">This field is required.</div> : null}
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Country you are based in</div>
                                    <Select name="traits.country" options={countryCodes}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.code}
                                            value={countrySelected}
                                            placeholder=""
                                            onChange={ev => {
                                                setCountry(ev.code);
                                                setCountrySelected(ev)
                                                console.log(ev);
                                            }}
                                            styles={styles.registerStyles}
                                            required={true}
                                    />
                                    {showCountryReminder ? <div className="messages">This field is required.</div> : null}
                                </div>
                            </div>
                            <div className="field-input-consent">
                                <div className="field-input-entry">
                                    <input name="traits.processing" type="hidden" value={processingConsent ? 1 : 0}/>
                                    <Slider state={processingConsent} update={updateProcessingConsent.bind(this)}
                                            text="I have read and accepted the CCMI Terms of Use and Privacy Policy"
                                            elem={<>I have read and accepted the CCMI <Link to='/terms-of-use' className="register-span">Terms of Use</Link> and <Link to='/privacy' className="register-span">Privacy Policy</Link></>}
                                    />
                                    {showConsentReminder ? <div className="messages">This field is required.</div> : null}
                                </div>
                            </div>
                            <div className="field-input">
                                <div className="field-input-entry">
                                    <div className="label">Marketing Consent</div>
                                    <div className="register-marketing-consent-label regular">
                                        CCMI respects your data and privacy. You can unsubscribe at any time.
                                        See our <a href="/privacy">Privacy Policy</a> for more details.
                                    </div>
                                    <input name="traits.marketing" type="hidden" value={marketingConsent ? 1 : 0}/>
                                    <Slider state={marketingConsent} update={updateMarketingConsent.bind(this)}
                                            elem={<><b>CCMI Newsletter.</b> Get the latest news, blogs and thought
                                            leadership on Coaching,
                                            Mentoring and Leadership from Professor David Clutterbuck every few
                                            months.</>}/>
                                    <div className="register-marketing-spacer"/>
                                    <input name="traits.diagnostic" type="hidden" value={diagnosticConsent ? 1 : 0}/>
                                    <Slider state={diagnosticConsent} update={updateDiagnosticConsent.bind(this)}
                                            elem={<><b>PERILL Diagnostic.</b> Keep me informed about CCMI’s PERILL Diagnostic platform updates,
                                            promotional offers and commercial opportunities for you related to it.</>}/>
                                    <input name="traits.coaching" type="hidden" value={coachingConsent ? 1 : 0}/>
                                    <div className="register-marketing-spacer"/>
                                    <Slider state={coachingConsent} update={updateCoachingConsent.bind(this)}
                                            elem={<><b>Team Coaching.</b> Keep me informed about courses and
                                                promotional offers from CCMI and
                                                (occasionally) from carefully selected partners about Team Coaching –
                                                don’t worry we won’t share your personal details with them.</>}/>
                                </div>
                            </div>
                            <div className="field-input mobile-align">
                                {!email || !firstName || !lastName || !organisation || !country ||
                                !orgRole || !checkAllPasswordConditions() || !processingConsent ?
                                    <button className="register-button invalid link" name="method" type="button"
                                            value="password" onClick={handleFalseButtonClick}
                                    >
                                        Register
                                    </button>
                                    :
                                    <button className="register-button link" name="method" type="submit"
                                            value="password"
                                            onClick={() => {localStorage.setItem("comingFromRegistration", "true")}}
                                            disabled={!email || !firstName || !lastName || !organisation ||
                                                !country || !orgRole || !checkAllPasswordConditions() ||
                                                !processingConsent}>
                                        Register
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
)
}

export default Register